module.exports = __webpack_public_path__ + "img/day06.af1c01e9.png";